export enum AtomLinkSizeEnum {
  BODY_BOLD = "body/bold",
  REGULAR = "regular",
  SMALL = "small",
}
